module.exports = __webpack_public_path__ + "static/Tastea2-9c396c4ee7f7b2170b3b5341d1a736a1.jpg";